// eslint-disable-next-line
import Symbol_observable from 'symbol-observable'

// import 'antd/lib/style/index.less' // antd core styles
// import './components/kit/vendors/antd/themes/default.less' // default theme antd components
// import './components/kit/vendors/antd/themes/dark.less' // dark theme antd components
import React, { useEffect, Suspense } from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter, useNavigate, useLocation } from 'react-router'
import { configureStore } from '@reduxjs/toolkit'
import { Provider } from 'react-redux'
import createSagaMiddleware from 'redux-saga'
import { ApolloProvider } from '@apollo/client'

import appolloClient from 'myNet'
import conf from 'conf'
import history from 'history'

import reducers from './redux/reducers'
import sagas from './redux/sagas'
import Localization from './localization'
import Router from './router'

import * as serviceWorker from './serviceWorker'

import './global.scss' // app & third-party component styles

// middlewared
const sagaMiddleware = createSagaMiddleware()
const middlewares = [sagaMiddleware]

console.info(`${conf.packageInfo.name} ${conf.packageInfo.version}`)
console.info(`Git branch : ${conf.gitInfo.branch}`)
console.info(`Git date : ${conf.gitInfo.commit.date}`)

const store = configureStore({
  reducer: reducers(),
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ thunk: false, immutableCheck: false, serializableCheck: false }).concat(
      middlewares,
    ),
  devTools: process.env.REACT_APP_TARGET !== 'production',
})

sagaMiddleware.run(sagas)

const NavigateSetter = () => {
  history.navigate = useNavigate()
  history.location = useLocation()

  const { location, notifyLocationChange } = history

  useEffect(() => {
    notifyLocationChange(location)
  }, [location, notifyLocationChange])

  return null
}

const root = ReactDOM.createRoot(document.getElementById('root'))

const browserRouterAttrs = {
  // future: {
  //   v7_startTransition: true,
  //   v7_relativeSplatPath: true,
  // }
}

root.render(
  <ApolloProvider client={appolloClient}>
    <BrowserRouter {...browserRouterAttrs}>
      <NavigateSetter />
      <Provider store={store}>
        <Localization>
          <Suspense fallback={<div>Loading...</div>}>
            <Router history={history} />
          </Suspense>
        </Localization>
      </Provider>
    </BrowserRouter>
  </ApolloProvider>,
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
export { store, history }
